const styles = (theme) => ({
  container: {
    padding: theme.spacing(2.5),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  growBlock: {
    flexGrow: 1,
  },

  phoneTypesContainer: {
    padding: theme.spacing(2.5),
    display: 'flex',
    flexDirection: 'column',
  },

  phoneTypeItem: {
    padding: `${theme.spacing(1.5)}px 0`,
    width: '100%',
  },
});

export default styles;
